export default {
  title: {
    cashOutManagement: '奖励发放管理'
  },
  menu: {
    cashOutManagement: '奖励发放管理'
  },
  label: {
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    rewardType: '奖励类型',
    selectedReferrer: '已选择的推荐者：',
    sumOfEarnings: '总收入：',
    referrer: '推荐者',
    earnings: '收入',
    operator: '更新者',
    payDate: '迁移日期'
  },
  btn: {
    outReward: '转账',
    export: '导出'
  },
  message: {
    confirmPayRewardTip: '确认转账？',
    confirmPayRewardType: '他们是通过{rewardType}支付。',
    confirmPayRewardAllType: '他们包含微信红包，积分和公司支付，请确保这些推荐者的信息已被导出。',
    confirmPayRewardContent: '请确定要给这些推荐者转帐?',
    endDateAfterStartDate: '开始日期必须小于截止日期!',
    payRewardSuccess: '转账成功!'
  },
  ALLOCATE_MAP: {
    PENDING: '未转账',
    TRANSFERRED: '已转账'
  },
  REWARD_TYPE_MAP: {
    CASH: '现金',
    POINTS: '积分',
    PAYROLL: '工资'
  }
}
